import { PlantingEvents, StoreCrops } from '../../types';
import { QueryPlantingEventsResponse } from './types/QueryPlantingEventsResponse';
import { adaptUapiPlantingResponse } from './uapiPlantingAdapter';
import { LegacyCropsMap } from './types/LegacyCropsMap';
import { getPlantingQuery } from './plantingQuery';
import { uapiConnection } from '../uapiConnection';

export async function requestUapiPlantingEvents(fieldUuid: string, cropsMap: StoreCrops): Promise<PlantingEvents> {
  const response = (await uapiConnection(
    getPlantingQuery({ fieldId: fieldUuid }),
  )) as QueryPlantingEventsResponse;

  const crops: LegacyCropsMap = Object.entries(cropsMap).reduce((accum, [legacySeasonCode, crop]) => ({
      ...accum,
      [crop['dfp-uuid']]: legacySeasonCode,
    }), {});

  return adaptUapiPlantingResponse(response.data.field.plantingEventAggregates?.eventsByCropSeason || [], crops);
}
